import {format, formatDistanceToNow} from 'date-fns';
import {ja} from 'date-fns/locale';
import {isValidDate, toJstDate} from './dateUtils';

/** JST で整形 */
export const formatInJst = (
  timestamp: string,
  pattern: string,
  options?: Parameters<typeof format>[2],
): string => format(toJstDate(new Date(timestamp)), pattern, options);

/** 日付をスラッシュ区切りで表示 例: 2024/12/17 */
export const formatDate = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatInJst(timestamp, 'yyyy/MM/dd');
};

/** ISO日付文字列をスラッシュ区切りで表示 例: 2024/12/17 */
export const formatDateFromIsoDate = (isoDateString: string): string => {
  if (!isValidDate(isoDateString)) return '';
  return formatInJst(isoDateString, 'yyyy/MM/dd');
};

/** 日本語形式（年月日）例: 2024年12月17日 */
export const formatDateJapanese = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatInJst(timestamp, 'yyyy年MM月dd日');
};

/** 日本語形式（年月）例: 2024年12月 */
export const formatDateToJapaneseYearMonth = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatInJst(timestamp, 'yyyy年MM月');
};

/** 年なし日本語形式（月日）例: 12月17日 */
export const formatDateToJapaneseMonthDay = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatInJst(timestamp, 'M月d日');
};

/** 年なし日本語形式（月のみ）例: 12月 */
export const formatDateToJapaneseMonth = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatInJst(timestamp, 'M月');
};

/** 現在からの相対時間を日本語で表示 例: 3日前、約1ヶ月前 */
export const formatDateDistanceToNow = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatDistanceToNow(new Date(timestamp), {locale: ja});
};

/** 日時を秒まで表示 例: 2024/12/17 14:30:45 */
export const formatDateToSeconds = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatInJst(timestamp, 'yyyy/MM/dd HH:mm:ss');
};

/** 日時を分まで表示 例: 2024/12/17 14:30 */
export const formatDateToMinutes = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatInJst(timestamp, 'yyyy/MM/dd HH:mm');
};

/** 月日をスラッシュ区切りで表示（ゼロ埋め）例: 12/17 */
export const formatDateToMonthDay = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatInJst(timestamp, 'MM/dd');
};

/** 月日を曜日付きで表示（ゼロ埋めなし）例: 12/17 (火) */
export const formatDateToMonthDayZeroSuppress = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatInJst(timestamp, 'M/d (eee)', {locale: ja});
};

/** 月日と時刻を曜日付きで表示 例: 12/17 (火) 14:30 */
export const formatDateWithTime = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatInJst(timestamp, 'M/d (eee) H:mm', {locale: ja});
};

/** 日時をフル表示（分まで）例: 2024/12/17 14:30 */
export const formatDateFullWithTime = (timestamp: string): string => {
  if (!isValidDate(timestamp)) return '';
  return formatInJst(timestamp, 'yyyy/MM/dd H:mm');
};
